import { render, staticRenderFns } from "./FormQuestionList.vue?vue&type=template&id=0ed1835d&scoped=true&"
import script from "./FormQuestionList.vue?vue&type=script&lang=js&"
export * from "./FormQuestionList.vue?vue&type=script&lang=js&"
import style0 from "./FormQuestionList.vue?vue&type=style&index=0&id=0ed1835d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed1835d",
  null
  
)

export default component.exports